import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio169: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-16-9, landscape"><path d="M5.75 5C3.12665 5 1 7.12665 1 9.75V14.25C1 16.8734 3.12665 19 5.75 19H18.25C20.8734 19 23 16.8734 23 14.25V9.75C23 7.12665 20.8734 5 18.25 5H5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAspectRatio169;
